package views.coletor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import ffButton0
import ffCheckBoxInput
import ffEspHorizontalMM
import ffEspHorizontalP
import ffMsgAviso
import ffMsgWindow
import ffSpan
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.clear
import lbTitulo
import model.Inotas
import model.Notas
import model.Produto
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import utils.ff.Companion.ffPercVer
import utils.ff.Companion.goEMPRESA
import utils.ff.Companion.goFUNCIONARIO
import utils.ff.Companion.gsBrowser
import utils.ff.Companion.gsParam1
import utils.ff.Companion.println0
import views.componentes.*
import kotlin.js.Date

class col003 {

    private val _t = "col003"
    private var onot: Notas = Notas()
    private var oino = Inotas.InotasResu()
    private var loino = ArrayList<Inotas.InotasResu>()
    //private var inQuantidade: HTMLInputElement? = null
//    private var bNovoItem = true

    private var param1 = ""
    private var sDadosBar = ""

    val tab1 = table1()

    fun show(_param1: String) {

        lbTitulo!!.innerText = "003 - Itens da nota fiscal"

        param1 = _param1
        //println0(param1)
        onot = Notas().construtorLista(param1).get(0)

        prepare(false)
    }

    fun prepare(_b: Boolean = false) {

//        bNovoItem = true

        ffMsgAviso("")

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()
        renderComposable(rootElementId = "htmlDiv1") {
            body2(_b)
        }
    }

    @Composable
    fun body2(_b: Boolean) {

        val _bAuto = remember { mutableStateOf(_b) }

        Div(attrs = { classes("form-group", "dlg-pad-top-5"); tabIndex(0) }) {

            //println0("zuza22 voltou ao inicio")
            val _tela = remember { mutableStateOf("") }
            val _inot_qtdcont = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inQuantidade")) }
            val _seOpcao = remember { mutableStateOf(gsInput(_t)) }
            val _novo = remember { mutableStateOf(false) }
            val _inProdutoQtd = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inProdutoQtd")) }
            val _inPerConcluido = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inPerConcluido", _text = "0")) }
            val sBtText = remember { mutableStateOf("01") }
            sBtText.value = if (goEMPRESA.EMP_COLDIGPROD.equals("NS")) ":01" else ":ab"

            Div({ classes("input-group") }) {
                ffSpan("Lote de entrega: ${onot.NOT_ENTRSEQUENCIA}", _width = 50)
                ffSpan("${_inPerConcluido.text()} %", _width = 50, _align = "right")
            }

            Div({ classes("form-group", "input-group") }) {
                ffSpan("Nota: ${onot.NOT_NRNOTA}", _width = 50)
                ffSpan("OF: ${onot.NOT_OF}", _width = 50, _align = "right")
            }

            Div {
                ffCheckBoxInput("Código ou EAN, marque para automatizar", _bAuto, 100)
            }

            //val _key = remember { mutableStateOf("") }
            //println0("zuza23 voltou ao inicio")

            //Form(action = "#", attrs = { onSubmit { it.preventDefault() } })
            //{

            //val _inProduto = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inProduto", _text = "")) }
            val _inProduto = remember { mutableStateOf(gsInput(_t, _id = "${_t}_inProduto")) }
            println0("878787-voltou para a criação do _inProduto = ${_inProduto.text()}")

            Div({ classes("input-group-append") }) {

                ffInput44("", _inProduto, goEMPRESA.EMP_COLDIGPROD, 0, 100, false,
                    _onFocusIn = {
                        if (_inProduto.enabled()) {
                            _inProduto.status("")
                            _tela.value = ""
                            _novo.value = true
                        }
                    },
                    _onFocusOut = {
                        //_tela.value = ""
                        _inProdutoFOCUSOUT1(_inProduto, _seOpcao, _inProdutoQtd, _novo, _inot_qtdcont, _tela, "")
                        /*
                        if (!_inProduto.text().equals("")) {
                            _inProdutoFocusOut(_inProduto, _seOpcao, _inProdutoQtd, _novo) { o ->

                                //ffMsgWindow("_inProduto.status ${_inProduto.status()}")
                                if (o) {
                                    _tela.value = "notaItem"
                                    //_inot_qtdcont.setFocus()
                                    _inot_qtdcont.text("1")
                                    if (oino.INOT_QTDCONT < oino.INOT_QTD)
                                        ffAudio().ffPlayBeep(true)
                                    else
                                        ffAudio().ffPlayBeep(false)
                                } else {
                                    ffAudio().ffPlayBeep(false)
                                }
                            }
                        }

                         */

                    })

                ffButton0(sBtText.value, {
                    goEMPRESA.EMP_COLDIGPROD = if (goEMPRESA.EMP_COLDIGPROD.equals("NS")) "S" else "NS"
                    sBtText.value = if (goEMPRESA.EMP_COLDIGPROD.equals("NS")) ":01" else ":ab"
                    goEMPRESA.atualizaEmpresa()
                }, 40)

            }

            body3(_tela, _bAuto, _inProduto, _inProdutoQtd,
                _inPerConcluido, _inot_qtdcont, _seOpcao, _novo)

        }
    }

    @Composable
    private fun body3(
        _tela: MutableState<String>,
        _bAuto: MutableState<Boolean>,
        _inProduto: MutableState<String>,
        _inProdutoQtd: MutableState<String>,
        _inPerConcluido: MutableState<String>,
        _inot_qtdcont: MutableState<String>,
        _seOpcao: MutableState<String>,
        _novo: MutableState<Boolean>
    ) {

        println("@investigar abrindo body3 _tela=${_tela.value}")
        println0(oino)

        val _inLote = remember { mutableStateOf(gsInput(_t)) }
        val _inValidade = remember { mutableStateOf(gsInput(_t)) }
        val _inFabricacao = remember { mutableStateOf(gsInput(_t)) }
        val _inQtdEmb = remember { mutableStateOf(gsInput(_t)) }
        val _table1Controler = remember { mutableStateOf(gsInput(_t)) } //limpar o value após o uso
        val _bResto = remember { mutableStateOf(false) }
        val _btGravar = remember { mutableStateOf(gsInput(_t, _id = "btGravar", _text = "Gravar", _enabled = false)) }

        //if (_inProduto.status().equals("ok")) {

        if (_novo.value == true) {
            _novo.value = false
            _inLote.text("")
            _inValidade.text("")
            _inFabricacao.text("")
            _inQtdEmb.text("")

            _inLote.enabled(true)
            _inValidade.enabled(true)
            _inFabricacao.enabled(true)
            if (goEMPRESA.EMP_ENTRFRACIONADA.equals("S"))
                _inQtdEmb.enabled(true)
            else
                _inQtdEmb.enabled(false)
        }

        if (!_inProduto.text().equals("") && onot.NOT_FINALIDADE == 1) {
            _inLote.enabled(false)
            _inValidade.enabled(false)
            _inFabricacao.enabled(false)
            _inQtdEmb.enabled(false)
        }

        if (_tela.value.contains("notaItem") || _tela.value.equals("")) {
            //println0("zuza1234 entrou aqui ${_inProduto.value} ${_inValidade.value}")

            Div {
                if (!_inProdutoQtd.text().equals("") && !_inProduto.text().equals("")) {
                    //println0("zuza9999 vai criar o input= ${_inProdutoQtd.text()}")
                    ffInput1("", _inProdutoQtd, "NS", 0, 100, false)
                    //_inProdutoQtd.text("CAIXA COM ${_inProduto.text()}")
                    _inProdutoQtd.enabled(false)
                } else if (_inProduto.equals("")) {
                    _inProdutoQtd.text("")
                }
            }

            Div({ classes("input-group") }) {

                //if (_tela.value == "notaItem") {
                println0("montando _seOpcao")
                if (_seOpcao.textItens() == "")
                    _seOpcao.textItens(getSemelhanteSeq(oino.INOT_PROD, loino))
                ffCombo(
                    "Ordem | Qtd",
                    _seOpcao,
                    "fal-",
                    40,
                    "",
                    true,
                    {
                        //_inProdutoFocusOut(_inProduto, _seOpcao, _inProdutoQtd, _novo) { }
                        println0("@investigar evento do _seOpcao")
                        if (oino.INOT_ORDEM != _seOpcao.textSelect().ffCopy(1, _seOpcao.textSelect().indexOf("/"))
                                .ffVsi()
                        ) {
                            oino = loino.filter { p ->
                                p.INOT_ORDEM == _seOpcao.textSelect().ffCopy(1, _seOpcao.textSelect().indexOf("/"))
                                    .ffVsi()
                            }.get(0)

                            _novo.value = true
                        }
                    }
                )


                //ffInput1Acao("Quantidade", _inot_qtdcont, "N", 0, 33, _acao = { btGravar.value = "ok" })
                ffInput1("Quantidade", _inot_qtdcont, "N", 0, 30,
                    _onFocusIn = { _inot_qtdcontFOCUSIN(_seOpcao, _btGravar, _inProduto, _inot_qtdcont) },
                    _onFocusOut = {})
                /*
                ffInput44("Quantidade", _inot_qtdcont, "N", 0, 30,
                    _onFocusIn = {
                        //_seOpcao.textSelect(_seOpcao.getHTMLSelectElement()!!.value)
                        //println0(_seOpcao.getHTMLSelectElement()!!.selectedOptions)
                        _inot_qtdcontFOCUSIN(_seOpcao, btGravar)
                    }, _onFocusOut = {})

                 */

                _inot_qtdcont.onKeyPressENTER {
                    //ffMsgAvisoc("", "Enter pressionado ok=${btGravar.value} _inProdutoStatus=${_inProduto.status()}")
                    //msgAviso("Enter pressionado")
                    if (!_btGravar.status().equals("ok") && _inProduto.status().equals("ok"))
                        _btGravar.status("ok")
                }

//                ffButtonDiv(
//                    "Gravar",
//                    _onclick = { if (!btGravar.value.equals("ok")) btGravar.value = "ok" },
//                    29
//                )
                //}
                ffButton(
                    _btGravar,
                    _onclick = { if (!_btGravar.status().equals("ok")) _btGravar.status("ok") },
                    29
                )

                println0(
                    "@bAuto=${_bAuto.value} _inProduto.status=${_inProduto.status()} " +
                            "_seOpcao.cout()=${_seOpcao.count()} _inProduto.codigo=${_inProduto.text()}"
                )
                if (_bAuto.value && _inProduto.status().equals("ok") && _seOpcao.count() == 1 && _inLote.text() != "") {
                    _btGravar.status("ok")
                    _inProduto.status("")
                }

                if (_btGravar.status().equals("ok") && !_inProduto.text().equals("")) {

                    _btGravar.status("")
                    println0(
                        "gravar0000 aqui ${_inProduto.text()} _seOpcao = ${_seOpcao.textSelect()}" +
                                " _inProdutoQtd = ${_inProdutoQtd.text()}" +
                                " com = ${_inProdutoQtd.text().ffPegaCampoAte("COM ", " ")}"
                    )
                    //_btGravar.status("")

                    if (oino.PROLOT_QUARENTENA == "S") {
                        ffMsgWindow("Atenção: Produto em quarentena, é necessário regravar a OF !")
                        _inot_qtdcont.text("0")
                    }

                    println0("zuza9997 _seOpcao = ${_seOpcao.textSelect()}")
                    onClickbtGravar(
                        _inProduto,
                        _inot_qtdcont,
                        _inProdutoQtd,
                        _seOpcao,
                        _inLote,
                        _inValidade.text(),
                        _inFabricacao.text(),
                        _inQtdEmb.text()
                    ) { _ok ->
                        if (_ok) {
                            _btGravar.status("")
                            _btGravar.enabled(false)
                            oino = Inotas.InotasResu()
                            ffMsgAviso("Gravado")

                            //_inProduto.atualizar()

                            //_inProduto.atualizar()
                            println0(
                                "_seOpcao- vai chamara a atualização" +
                                        " not_finalidade=${onot.NOT_FINALIDADE}" +
                                        " EST_CONTRLOTE=${oino.EST_CONTRLOTE}" +
                                        " selectCount=${_seOpcao.selectCount("fal-").toString()}" +
                                        " _inot_qtdcont=${_inot_qtdcont.text()}"
                            )
                            if (onot.NOT_FINALIDADE == 1 && _seOpcao.selectCount("fal-") > 0 && _seOpcao.selectCount("") > 1
                                && _inot_qtdcont.text().ffVsdo() > 0.0
                            ) {
                                println0("_seOpcao- vai chamara a atualização")
                                //val sCont = _inQtdEmb.text()
                                //val sProd = _inProduto.text()
                                //prepare(_bAuto.value)
                                //_inProduto.enabled(true)
                                //_inProduto.text(sProd)
                                //_inQtdEmb.setFocusSimples()

                                _btGravar.status("continuo")
                                _inProdutoFOCUSOUT1(_inProduto, _seOpcao, _inProdutoQtd, _novo, _inot_qtdcont, _tela, "continuo")
                                _inot_qtdcontFOCUSIN(_seOpcao, _btGravar, _inProduto, _inot_qtdcont)
                                _btGravar.status("")
                                //_seOpcao.textItens(getSemelhanteSeq(oino.INOT_PROD, loino))
                                //_seOpcao.comboLocaliza(_seOpcao.textSelect(_seOpcao.selectLocalize("fal-")))
                                //println0("Quantidade restante ${_inot_qtdcont.text()} vai para a contagem do próximo lote, clique na quantidade.")

                                window.scrollTo(0.0, 0.0)
                                //_inot_qtdcont.setFocus("true", true)
                                //_bResto.value = true
                                ffMsgWindow("Quantidade restante ${_inot_qtdcont.text()} vai para a contagem do próximo lote, clique na quantidade.")
                                //_btGravar.enabled(true)
                                //ff().ffSetFocus(_seOpcao.id())
                                //ff().ffSetFocus(_inot_qtdcont.id())

                                //_inQtdEmb.text(sCont)
                                //_inQtdEmb.setFocus()
                                //_inProduto.enabled(false)
                                //_seOpcao.atualizar()
                            } else {

                                _inProduto.text("000000")
                                _inProduto.enabled(true)
                                _inProduto.value = gsInput(_t, _id = "${_t}_inProduto")
                                _inot_qtdcont.value = gsInput(_t, _id = "${_t}_inQuantidade")

                                //println0("zuza9999 vai limpar a _inValidade")
                                _inValidade.text("")
                                //println0("zuza9999 limpou _inValidade ${_inValidade.text()}")
                                _inFabricacao.text("")
                                _inLote.text("")
                                _inProduto.setFocus("true")

                                show(param1)
                                prepare(_bAuto.value)
                                window.scrollTo(0.0, 0.0)
                            }
                        }
                    }
                }
            }

            //(document.getElementById("inQuantidate") as HTMLInputElement).focus()
            if (!_inProduto.text().equals("") && oino.EST_CONTRLOTE.equals("S")) {
                Div({ classes("form-group", "input-group") }) {
                    ffInput1("Qtd. Emb", _inQtdEmb, "N", 9999, 13)
                    ffInput1("Lote", _inLote, "S", 0, 29)
                    ffInput1(_text = "Validade", _valor = _inValidade, _tipoCampo = "D2", _max = 0, _width = 29,
                        _onFocusIn = {},
                        _onFocusOut = {
                            val dt1 = _inValidade.text().ffDsd()
                            val dt2 = dt1.ffSoma(oino.EST_DIASVALID.times(-1))
                            println0("${_inValidade.text()} $dt1 $dt2 ${oino.EST_DIASVALID}")
                            _inFabricacao.text(dt2.ffDdBr(2))
                        })
//                    _inValidade.onKeyPressENTER {
//                    }
                    ffInput1("Fabricação", _inFabricacao, "D2", 0, 29, {}, {})
                    //ffInputN("Quantidade: ", _qtde, "N", 9, 45, true)
                    //if (goEMPRESA.EMP_ENTRFRACIONADA.equals("N"))
                    //_inFabricacao.getHTMLInputElement()!!.enabled(false)

                    _inFabricacao.onKeyPressENTER {
                        _inot_qtdcont.setFocusSimples()
                        //_inot_qtdcont.setFocusSimples()
                        //btGravar.value = "ok"
                    }
                }
            }

            //área do grid table
            if (loino.getOrNull(0) == null || _table1Controler.text().equals("")) {
                atualiza_linotas { o ->
                    _table1Controler.text("imprima")
                    for (obj in loino) {
                        if (obj.INOT_PROLOTID > 0)
                            obj.OO_DESCPROD =
                                "${obj.INOT_ORDEM.ffZeroLeft(2)} - ${obj.INOT_PROD.ffZeroLeft(6)}" +
                                        " - ${obj.INOT_DESCPROD} - lote=${obj.INOT_PROLOTID.ffZeroLeft(6)} / ${obj.PROLOT_LOTEFAB}"
                        else
                            obj.OO_DESCPROD =
                                "${obj.INOT_ORDEM.ffZeroLeft(2)} - ${obj.INOT_PROD.ffZeroLeft(6)}" +
                                        " - ${obj.INOT_DESCPROD}";
                    }
                    println0(loino)
                }
            }
            Div({ classes("form-group", "input-group") }) {
                ffButton0("Novo item", {
                    _btGravar.status("")
                    _tela.value = ""
                    prepare(_bAuto.value)
                }, 48)

                ffEspHorizontalP(4)
                ffButton0(
                    "Consultar", {
                        gsParam1 = param1
                        ff().ffLocalizarProduto(_inProduto.text().ffPegaId().trim())
                    },
                    48
                )
            }

            if (loino.size > 0 || !_table1Controler.text().equals("")) {

                val lcon = ArrayList<table1>()
                lcon.add(table1().add(40, "S", "N", "OO_DESCPROD    ", "Ordem - Produto"))
                if (goEMPRESA.EMP_CONFCEGAS != "S") {
                    lcon.add(table1().add(15, "N", "N", "INOT_QTD       ", "Qtd"))
                    lcon.add(table1().add(15, "N", "N", "OO_QTDFALTA    ", "Falta"))
                } else {
                    lcon.add(table1().add(15, "N", "N", "INOT_QTDCONT   ", "Contada"))
                    lcon.add(table1().add(15, "N", "N", "OO_COLUMN1     ", "Status"))
                }
                //lcon.add(table1().add(20, "D", "N", "PROLOT_DTVAL   ", "Validade"))

                //var sLista = ""
                if (onot.NOT_NOTATIPO.equals("W")) {
                    val loino1 = loino.filter({ p -> p.INOT_INDPROITIPO.equals("A") }).toList()
                    loino = ArrayList(loino1)
                }
                _inPerConcluido.text( ffPercVer(loino.sumOf { a -> a.INOT_QTD }, loino.sumOf { a -> a.INOT_QTDCONT }).toString() )
                for (o in loino) {
                    o.OO_COLUMN1 = o.OO_FALTASN + " " + o.PROLOT_DTVAL.ffDdBr(2)
                    //o.OO_COLUMN1 = gerarStringComQuebraDeLinha(o.OO_FALTASN, o.PROLOT_DTVAL.ffDdBr(2))
                }


                //println0("zuza33")
                if (goEMPRESA.EMP_CONFCEGAS == "S") {
                    val sortedList =
                        loino.sortedBy { it.INOT_ORDEM }.sortedByDescending { it.INOT_QTDCONT }.sortedByDescending { it.OO_FALTASN }
                    //println("imprimindo sortedList")
                    //println(sortedList)
                    tab1.ffTable1(
                        lcon,
                        JSON.stringify(sortedList).ffJsonParse(false),
                        _table1Controler = _table1Controler,
                        _tbTipo = "Black"
                    )
                } else {
                    val sortedList =
                        loino.filter { p -> p.INOT_QTD != p.INOT_QTDCONT }
                            .sortedBy { it.INOT_ORDEM }.sortedByDescending { it.INOT_QTDCONT }.sortedByDescending { it.OO_FALTASN }
                    //sortedList = sortedList.filter { p -> p.INOT_QTD != p.INOT_QTDCONT }
                    tab1.ffTable1(
                        lcon,
                        JSON.stringify(sortedList).ffJsonParse(false),
                        //JSON.stringify(loino.filter { p -> p.INOT_QTD != p.INOT_QTDCONT }).ffJsonParse(false),
                        _table1Controler = _table1Controler,
                        _tbTipo = "Black"
                    )
                }
            }

            Div({ classes("form-group", "input-group") }) {
                ffButton0(
                    "Recontar divergências",
                    {
                        onClickRecontar { o ->
                            _table1Controler.text("")
                            prepare(_bAuto.value)
                        }
                    },
                    48
                )
                ffEspHorizontalMM(3)
                ffButton0("Fechar", { principalCOL().ffNavePage("col002", onot.NOT_OF.toString()) }, 48)
            }
            Div({ classes("form-group", "input-group") }) {
                ffButton0(
                    "Volumes",
                    {
                        col002().show(onot.NOT_OF.toString())
                    },
                    100
                )
            }

            if (oino.EST_CONTRLOTE.equals("S")) {
                if (!_inProduto.text().equals("")
                    && _inLote.text().equals("") && _inQtdEmb.text().equals("")
                    && (!oino.INOT_LOTEXML.ffPegaCampo("|lote").equals("") || sDadosBar != "")
                ) {
                    println0("@investigar populando _inLote = ${oino.INOT_LOTEXML.ffPegaCampo("|lote")} qtdcont = ${oino.INOT_QTDCONT}")
                    //println0("zuza9999_ INOT_LOTEXML = ${oino.INOT_LOTEXML}, _inProduto = ${_inProduto.status()}")
                    //println0("." + oino.INOT_LOTEXML.trim() + ".")
                    _inLote.text(oino.INOT_LOTEXML.ffPegaCampo("|lote"))
                    _inValidade.text(oino.INOT_LOTEXML.ffPegaCampo("|val").ffDsBr())
                    _inFabricacao.text(oino.INOT_LOTEXML.ffPegaCampo("|fab").ffDsBr())
                    _inQtdEmb.text(oino.INOT_LOTEXML.ffPegaCampo("|qtdemb"))

                    println0("sDadosBar=$sDadosBar")
                    if (sDadosBar != "") {
                        if (_inLote.text().equals("")) {
                            _inLote.text(sDadosBar.ffPegaCampo("lote="))
                            _inValidade.text(sDadosBar.ffPegaCampo("dataValidade="))
                            _inFabricacao.text(sDadosBar.ffPegaCampo("dataFabricacao="))
                        }
                        //sDadosBar = ""
                    }

                    //if (_inQtdEmb.text().equals(""))
                    //    _inQtdEmb.text(oino.PRO_QTEMB.toString())

                    //mensagem("col003","VALOR = ${oino.INOT_QTDCONT}")
                    if (!_inLote.text().equals("") && oino.INOT_QTDCONT != 0.0) {
                        println0("@investigar desabilitando _inLote")
                        _inLote.enabled(false)
                        _inValidade.enabled(false)
                        _inFabricacao.enabled(false)
                    }

                }
            }

            if (oino.EST_CONTRLOTE.equals("S")) {
                if (_inQtdEmb.text().equals("")) {
                    if (goEMPRESA.EMP_ENTRFRACIONADA.equals("S")) {
                        _inQtdEmb.enabled(true)
                        _inQtdEmb.text("1")
                    } else {
                        _inQtdEmb.enabled(false)
                        _inQtdEmb.text(oino.PRO_QTEMB.toString())
                    }
                }
            }
        }

        if (loino.getOrNull(0) != null && loino[0].INOT_PROD == 0) {
            if ((onot.NOT_FINALIDADE == 1) && ((onot.NOT_DTVIG == ff.InicialDate) || (onot.NOT_QTCONF.equals(
                    "S"
                )))
            ) {
                ffMsgAviso("Nota já conferida, você pode alterar o volume na janela anterior!")
            }
        }

        if (_inProduto.text().equals("")) {
            _inProduto.setFocusSimples()
        }
        /*
        else if (_inot_qtdcont.text().equals("1")) { //&& (!_inLote.enabled() || !oino.EST_CONTRLOTE.equals("S"))) {

            println0("entrou no evento da quantidade")
            _inot_qtdcont.setFocusSimples(true)
            //_inot_qtdcont.select()
        }
         */


        /*
        else if (!_inLote.enabled() && onot.NOT_FINALIDADE == 1) {

            _inot_qtdcont.setFocusSimples(true)
            _inot_qtdcont.select()
        }

         */


        /*
        if (_inProduto.text().equals("")) {
            SideEffect {
                (document.getElementById("${_t}_inProduto") as HTMLInputElement).focus()
                //(document.getElementById("${_t}_inProduto") as HTMLInputElement).value = ""
                //_inProduto.setVal("12")
            }
        }

         */

    }


//******************************************************************************* INICIO DOS EVENTOS

    private fun onClickRecontar(callback: (Boolean) -> Unit): Boolean {

        for (obj in loino!!) {
            if ((obj.INOT_QTD != obj.INOT_QTDCONT) && (!obj.INOT_QTDCONT.equals(0.0))) {
                obj.INOT_QTDCONT = 0.0
                ff.println0("zerarDivergencias produto: ${obj.INOT_PROD} qtde: ${obj.INOT_QTD} qtcont: ${obj.INOT_QTDCONT}")
                if (onot.NOT_FINALIDADE == 1) //NOTA DE SAIDA
                    obj.INOT_LOTEXML = ""

                println0(obj.asDynamic())
                Service().postGen(obj.asDynamic(), "${ff.gsDom1}/notas/013/webestoque") { objReturn ->
                    if (objReturn.PAD_CODIGO.compareTo(200) == 0) {
                        println0("Contagem reiniciada")
                    }
                    callback(true)
                }
            }
        }

        return true
    }

    private fun onClickbtGravar(
        _inProduto: MutableState<String>,
        _inot_qtdcont: MutableState<String>,
        _inProdutoQtd: MutableState<String>,
        _seOpcao: MutableState<String>,
        _lote: MutableState<String>,
        _validade: String,
        _fabricacao: String,
        _qtdEmb: String,
        callback: (Boolean) -> Unit
    ) {

        println0("@investigar onClickbtGravar _inot_qtdcont = $_inot_qtdcont ou ${_inot_qtdcont.text().ffVsi()}")
        println0(
            "onClickbtGravar contrlote=${oino.EST_CONTRLOTE} validade=${_validade} fabricacao=${_fabricacao}" +
                    " lote=${_lote.text()} qtdEmb=${_qtdEmb} finalidade=${onot.NOT_FINALIDADE} opcao=${_seOpcao}"
        )

        val sOpcao1 = _seOpcao.textSelect()
        val iOrdem = sOpcao1.ffCopy(1, sOpcao1.indexOf("/")).ffVsi()
        println0("@investigar zuza9997 - $iOrdem sOpcao=$sOpcao1 seOpcao=$_seOpcao")

        println0("@investigar zuza9998 - $iOrdem")
        oino = loino.filter({ p -> p.INOT_ORDEM == iOrdem }).get(0)

        println0("@investigar zuza9999")
        if (oino.INOT_PROD == 0) {
            _inProduto.setFocus("true")
            ffMsgAviso("Informe o produto")
        }
        window.scrollTo(0.0, 0.0)
        var bContinua = true

        var cQtd: Double = _inot_qtdcont.text().ffVsdo()
        if (_inProdutoQtd.text().ffPegaCampoAte("COM ", " ").ffVsdo() > 0.0)
            cQtd = cQtd * _inProdutoQtd.text().ffPegaCampoAte("COM ", " ").ffVsdo()

        //acredito que aqui tenha atualizado o registro da nota sendo conferida
        if (oino.EST_CONTRLOTE.equals("S") && onot.NOT_FINALIDADE == 0 && (_validade.equals("") || _fabricacao.equals("")) ) {
            ffMsgAviso("Informe o lote, validade e fabricação")
            bContinua = false
        } else if (oino.EST_CONTRLOTE.equals("S") && _fabricacao.ffDsd()
                .compareNow() > 0 && onot.NOT_FINALIDADE == 0
        ) {
            ffMsgAviso("Data de fabricação maior que a data atual ou validade")
            bContinua = false
        } else if (oino.EST_CONTRLOTE.equals("S") && _validade.ffDsd()
                .compareNow() <= 0 && onot.NOT_FINALIDADE == 0
        ) {
            ffMsgAviso("Data de validade menor que a data atual")
            bContinua = false
        } else if (oino.EST_CONTRLOTE.equals("S") && _lote.text().equals("")) {
            ffMsgAviso("Informe o número do lote do fabricante")
            bContinua = false
        } else if (oino.EST_CONTRLOTE.equals("S") && _qtdEmb.equals("")) {
            ffMsgAviso("Informe a quantidade por embalagem")
            bContinua = false
        } else if (onot.NOT_FINALIDADE == 0 && //conferência apenas para notas de entrada
            _lote.text() != ""
            && cQtd > 0
            && loino.filter { p ->
                p.PROLOT_LOTEFAB.equals(_lote.text())
                        && p.INOT_QTDCONT > 0
                        && p.INOT_ORDEM != _seOpcao.textSelect().ffCopy(3).ffVsi()
                        && p.INOT_PROD == _inProduto.text().ffPegaId().ffVsi()
            }.toList().isNotEmpty()
        ) {
            ffMsgAviso("Lote informado já consta como lançado para essa NF")
            bContinua = false
        } else if (oino.EST_CONTRLOTE.equals("S")) {

            val lDia: Long = 86400000 // dia em milisegundos
            val lValidade: Double = (_validade.ffDsd().getTime().minus(Date(Date.now()).getTime())).div(lDia)
            val cPercentual = ff.ffPercVer(oino.EST_DIASVALID.toDouble(), lValidade)

            println0(
                "zuza9999_calulo_shelflife = ${onot.NOT_FINALIDADE} cPercentual = ${cPercentual}" +
                        " cli_shelflife = ${onot.CLI_SHELFLIFE00}" +
                        " not_notatipo = ${onot.NOT_NOTATIPO}" +
                        " not_finalidade = ${onot.NOT_FINALIDADE}" +
                        " est_diasvalidmin = ${oino.EST_DIASVALIDMIN}"
            )
            if (cPercentual < oino.EST_DIASVALIDMIN)
                println0("cPercentual é menor que EST_DIASVALIDMIN")
            if (cPercentual > oino.EST_DIASVALIDMIN)
                println0("cPercentual é maior que EST_DIASVALIDMIN")

            if (onot.NOT_FINALIDADE == 0 && cPercentual < oino.EST_DIASVALIDMIN && ("E,B").contains(onot.NOT_NOTATIPO)) { //ENTRADA TUDO PERCENTUAL
                ffMsgAviso("Número de dias (${lValidade.toInt()} / ${cPercentual}%) é menor que o shelf life permitido (${oino.EST_DIASVALIDMIN}%)!")
                bContinua = false
            }
            if (onot.NOT_FINALIDADE == 1 && cPercentual < onot.CLI_SHELFLIFE00) { //VENDA TUDO PERCENTUAL
                ffMsgAviso("Número de dias (${lValidade.toInt()} / ${cPercentual}%) é menor que o shelf life permitido (${onot.CLI_SHELFLIFE00}%)!")
                bContinua = false
            }
        }
        println0("onClickbrGravar00 chegou aqui")

        if (!bContinua) {
            _lote.setFocus("true")
            callback(false)
            //return false
        } else {

            var obj0: Inotas.InotasResu? = null
            Inotas.InotasResu().getProdutoOF("notas/012/empresa/${onot.NOT_OF}") { lista ->

                ff.println0("executando atualiza_linotas")
                var cQtdCont = cQtd
                if (onot.NOT_FINALIDADE == 1 && _seOpcao.selectCount("fal-") > 0 && _seOpcao.selectCount("") > 1) {
                    //if (oino.INOT_QTDCONT + cQtdCont >= oino.INOT_QTD) {
                    if (cQtdCont >= oino.INOT_QTD)
                        cQtdCont = oino.INOT_QTD - oino.INOT_QTDCONT
                    _inot_qtdcont.text((cQtd - cQtdCont).toString())
                    if (_inot_qtdcont.text().ffVsdo() < 0.0)
                        _inot_qtdcont.text("0")
                    println0("@investigar qtd ${_inot_qtdcont.text()} quantidade a ser usada cQtdCont = $cQtdCont")
                    //}
                }
                //if (onot.NOT_FINALIDADE == 1 && _seOpcao.selectCount("fal-") == 1) {
                //    _inot_qtdcont.text("0")
                //}

                val sLoteXML = "|lote${_lote.text()}|qtd${oino.INOT_QTD}" +
                        "|fab${_fabricacao}|val${_validade}|qtdemb${_qtdEmb}"

                oino.OO_USUSEPA = goFUNCIONARIO.FUNC_LOGON
                oino.INOT_QTDCONT += cQtdCont
                oino.PROLOT_QTDEMB = _qtdEmb.ffVsi()

                /*
                oino.OO_QTDFALTA = o.FATITE_QTDE - o.FATITE_QTCONT
                if (oino.OO_QTDFALTA == 0.0)
                    oino.OO_FALTASN = ""
                else if (oino.OO_QTDFALTA < 0)
                    oino.OO_FALTASN = "sobra"
                else
                    oino.OO_FALTASN = "falta"
                 */

                println0("zuzaaqui122 ${cQtd} ordem = ${oino.INOT_ORDEM}")
                if (oino.EST_CONTRLOTE.equals("S"))
                    oino.INOT_LOTEXML = sLoteXML

                obj0 = lista!!.getOrNull(0)

                if (obj0 != null) {
                    Service().postGen(oino.asDynamic(), "${ff.gsDom1}/notas/013/webestoque") { objReturn ->
                        obj0 = null
                        callback(true)
                    }
                }

            }

        }
    }

    //consulta o produto dentro da OF que está aberta
    private fun onkeyPress_produto(_inProduto: MutableState<String>, cb: (Boolean) -> Unit) {

        println0("@investigar onkeyPress_produto01 produto = ${_inProduto.key()} ${_inProduto.text()}")
        var bContinua = true

        if ((bContinua) && (_inProduto.text().equals(""))) {
            ffMsgAviso("Informe o produto")
            bContinua = false
        }

        if (bContinua) {
            sDadosBar = ""
            var iProduto = _inProduto.text().ffPegaId()
            if (iProduto.ffSoNumero().length > 14) {
                sDadosBar = Produto().decodificarCodigoBarras(iProduto.toString()).toString().ffTransfPegaCampo()
                if (sDadosBar.contains("gtin=")) {
                    iProduto = sDadosBar.ffPegaCampo("gtin=")
                }
            }

            println0(loino)

            val oino1 =
                loino.filter({ p -> p.ESTG_EANC == iProduto || p.ESTG_EAND == iProduto || p.ESTG_EANU == iProduto || p.INOT_PROD == iProduto.ffVsi() })
                    .toList().getOrNull(0)
            if (oino1 != null)
                iProduto = oino1.INOT_PROD.toString().ffPegaId()

            println0("zuza25 chegou aqui $iProduto")
            //val obj55 = Inotas.InotasResu()

            val sUrl = "notas/014/${ff.giEmpresa}/${onot.NOT_OF}/${iProduto.toString()}"
            Inotas.InotasResu().getProdutoOF(sUrl) { lProd1 ->
                //println0("@investigar 1z $sUrl")
                println0(lProd1)

                //conferir of de produtos de retorno da produção
                val lProd2 = ArrayList<Inotas.InotasResu>()
                for (obj in lProd1) {
                    //println0("@investigar 2z")
                    println0(obj)
                    lProd2!!.add(obj)
                    //println0("@investigar 3z")
                }
                println0(lProd2)
                println0("@investigar 4z")
                if (lProd2 != null) {
                    var sProduto = _inProduto.text().ffPegaId()
                    if (lProd2.count() > 0)
                        sProduto = lProd2.get(0).INOT_PROD.toString()
                    if (lProd2.size > 0) {
                        //println0("@investigar zuza77 ${_inProduto.text()} sProduto=$sProduto finalidade=${onot.NOT_FINALIDADE}")
                        //oino = lProd1.get(0)
                        var oino1: Inotas.InotasResu? = null
                        //valor de 21 é antigo pode descartar 07/02/2024
                        if (_inProduto.text().ffCopy(2).equals("98") && _inProduto.text().length == 21
                            && _inProduto.text().ffCopy(13, 9).equals("000000000")
                        ) {
                            oino1 = lProd2.filter { p ->
                                p.INOT_PROD == _inProduto.text().ffCopy(7, 6).ffVsi()
                            }.toList().getOrNull(0)
                        } else if (_inProduto.text().ffCopy(2).equals("98") && _inProduto.text().length == 21) {
                            oino1 = lProd2.filter { p ->
                                p.OO_BARRAS == _inProduto.text()
                            }.toList().getOrNull(0)

                        } else if (_inProduto.text().ffCopy(2).equals("98") && _inProduto.text().length == 22
                            && _inProduto.text().ffCopy(14, 9).equals("000000000")
                        ) {
                            println0("@investigar 5z")
                            oino1 = lProd2.filter { p ->
                                p.INOT_PROD == _inProduto.text().ffCopy(8, 6).ffVsi()
                            }.toList().getOrNull(0)
                        } else if (_inProduto.text().ffCopy(2).equals("98") && _inProduto.text().length == 22) {
                            println0("@investigar 6z")
                            oino1 = lProd2.filter { p ->
                                p.INOT_PROD == _inProduto.text().ffCopy(8, 6).ffVsi()
                                        && p.INOT_PROLOTID == _inProduto.text().ffCopy(14, 9).ffVsi()
                            }.toList().getOrNull(0)
                        } else {
                            oino1 = lProd2.filter { p ->
                                p.ESTG_EAN.equals(_inProduto.text()) ||
                                        p.PRO_REFER == _inProduto.text() ||
                                        p.INOT_PROD == sProduto.ffVsi() // _inProduto.text().ffVsi()
                            }.toList().getOrNull(0)
                        }

                        //println0("@investigar 5z")
                        println0(oino1)
                        println0("${oino1!!.INOT_PROD}")

                        //valor de 21 é antigo pode descartar 07/02/2024
                        if (((oino1.EST_OBRBARRALOTE.equals("S") && oino1.EST_CONTRLOTE.equals("S"))
                                    || (_inProduto.text().ffCopy(2).equals("98")) && _inProduto.text().length == 21)
                            && onot.NOT_FINALIDADE == 1
                        ) {
                            println0("Conferindo obrigação de lote")
                            var bOk = false
                            if (_inProduto.text().ffCopy(2).equals("98") && _inProduto.text().length == 21) {
                                if (_inProduto.text().ffCopy(13, 9).equals("")
                                    || oino1.INOT_PROLOTID == _inProduto.text().ffCopy(13, 9).ffVsi()
                                )
                                    bOk = true
                            }
                            if (!bOk) {
                                ffMsgWindow(
                                    "Produto correto mas o lote interno esperado é ${oino1.INOT_PROLOTID} " +
                                            "lote interno da caixa é ${_inProduto.text().ffCopy(13, 9).ffVsi().toString()}."
                                )
                                cb(false)
                            } else {
                                cb(true)
                            }
                        } else if (((oino1.EST_OBRBARRALOTE.equals("S") && oino1.EST_CONTRLOTE.equals("S"))
                                    || (_inProduto.text().ffCopy(2).equals("98")) && _inProduto.text().length == 22)
                            && onot.NOT_FINALIDADE == 1
                        ) {
                            println0("Conferindo obrigação de lote")
                            var bOk = false
                            if (_inProduto.text().ffCopy(2).equals("98") && _inProduto.text().length == 22) {
                                if (_inProduto.text().ffCopy(14, 9).equals("")
                                    || oino1.INOT_PROLOTID == _inProduto.text().ffCopy(14, 9).ffVsi()
                                )
                                    bOk = true
                            }
                            if (!bOk) {
                                ffMsgWindow(
                                    "Produto correto mas o lote interno esperado é ${oino1.INOT_PROLOTID} " +
                                            "lote interno da caixa é ${_inProduto.text().ffCopy(14, 9).ffVsi().toString()}."
                                )
                                cb(false)
                            } else {
                                cb(true)
                            }
                        } else {
                            cb(true)
                        }
                        oino = oino1

                    } else {
                        ffMsgWindow("Item não cadastrado ou fora da OF. $sUrl")
                        oino = Inotas.InotasResu()
                        cb(false)
                    }
                } else {
                    oino = Inotas.InotasResu()
                }
            }
        }
    }


//********************************************************************************* INICIO DAS FUNCOES

    private fun atualiza_linotas(callback: (Boolean) -> Unit) {

        ff.println0("executando atualiza_linotas")
        var bAtualizou = false
        Inotas.InotasResu().getProdutoOF("notas/012/empresa/${onot!!.NOT_OF}") { lista ->
            loino = lista as ArrayList<Inotas.InotasResu>
            //define as cores da fonte linha
            val repetidos = loino.groupBy { it.INOT_PROD }.filter { it.value.size > 1 }.keys
            for (o in loino) {
                if (o.INOT_PROD in repetidos) {
                    o.OO_CORLINHA = "yellow"
                }
            }

            //println0("quarentena12")
            //println0(loino)
            bAtualizou = true
            callback(bAtualizou)
        }
    }

    //retorna os itens que são iguais dentro do INOTAS, mesmo código
    private fun getSemelhanteSeq(_prod: Int, lista: (List<Inotas.InotasResu>)): String {

        var sResult = ""
        if (goEMPRESA.EMP_CONFCEGAS == "S") {
            //val listab: List<Inotas.InotasResu>? = null
            val listab = lista.filter { p -> p.INOT_PROD == _prod }
            for (obj in listab) {
                var s = "***"
                if (obj.INOT_QTD == obj.INOT_QTDCONT)
                    s = "bat"
                else if (obj.INOT_QTD > obj.INOT_QTDCONT)
                    s = "fal"
                else
                    s = "sob"
                sResult = "$sResult${obj.INOT_ORDEM.ffZeroLeft(3)}/$s-${obj.INOT_QTDCONT}#"
            }
        } else {
            val listab = lista.filter { p -> p.INOT_PROD == _prod && p.INOT_QTD != p.INOT_QTDCONT }
            for (obj in listab) {
                sResult = "$sResult${obj.INOT_ORDEM.ffZeroLeft(3)}/${obj.INOT_QTD}-${obj.INOT_QTDCONT}#"
            }
        }

        sResult += " "
        return sResult
    }

    //retorna os itens que são iguais dentro do INOTAS, mesmo código
    private fun getSemelhanteSeq1(_prod: Int, lista: (List<Inotas.InotasResu>)): String {

        var sResult = ""
        if (goEMPRESA.EMP_CONFCEGAS == "S") {
            var listab: List<Inotas.InotasResu>? = null
            listab = lista.filter { p -> p.INOT_PROD == _prod }
            if (listab == null) {
                listab = lista.filter { p -> p.INOT_PROD == _prod }
            }
            for (obj in listab) {
                sResult = "$sResult${obj.INOT_ORDEM.ffZeroLeft(3)}/P${obj.INOT_PROD.ffZeroLeft(6)}-${obj.INOT_QTDCONT}#"
            }
        } else {
            val listab = lista.filter { p -> p.INOT_PROD == _prod && p.INOT_QTD != p.INOT_QTDCONT }
            for (obj in listab) {
                sResult = "$sResult${obj.INOT_ORDEM.ffZeroLeft(3)}/${obj.INOT_QTD}-${obj.INOT_QTDCONT}#"
            }
        }

        sResult += " "
        return sResult
    }


    private fun _inProdutoFocusOut(
        _inProduto: MutableState<String>,
        _seOpcao: MutableState<String>,
        _inProdutoQtd: MutableState<String>,
        _novo: MutableState<Boolean>,
        callback: (Boolean) -> Unit
    ) {

        println0("@investigar _inProdutoFocusOut ${_inProduto.text()}")

        //val iOrdem = _seOpcao.textSelect().ffCopy(1, _seOpcao.textSelect().indexOf("/")).ffVsi()

        onkeyPress_produto(_inProduto) { bContinua ->
            println0("@investigar onkeyPress_produto ${_inProduto.text().ffPegaId()}")

            _seOpcao.textItens("")
            if (bContinua) {
                _inProduto.enabled(false)

                //tem que enviar uma consulta pelo código de barras para saber as unidades de venda a utilizar
                var opro: Produto? = null

                Produto().consultarProduto(_inProduto.text().ffPegaId(), false) { lista ->

                    ff().ffSetFocus("btCabecVoltar")
                    //if (_inProdutoQtd.text().ffVsdo() > 1.0)
                    //ff().ffSetFocus(_inProdutoQtd.id())
                    if (lista != null) {
                        opro = lista.filter({ i -> i.ESTG_EAN.equals(_inProduto.text()) }).toList().getOrNull(0)
                    }

                    if (onot.NOT_OF != 0) {

                        var obj: Inotas.InotasResu? = null

                        if (goEMPRESA.EMP_CONFCEGAS == "S") {
                            obj = loino.filter { i ->
                                i.INOT_PROD == oino.INOT_PROD
                                        && i.INOT_QTDCONT > 0.0
                                        && i.INOT_QTD != i.INOT_QTDCONT
                            }.getOrNull(0)
                            if (obj == null) {
                                obj = loino.filter { i ->
                                    i.INOT_PROD == oino.INOT_PROD
                                }.getOrNull(0)
                            }

                        } else {
                            obj = loino.filter { i ->
                                i.INOT_PROD == oino.INOT_PROD
                                        && i.INOT_QTDCONT > 0.0
                                        && i.INOT_QTD != i.INOT_QTDCONT
                            }.getOrNull(0)
                        }
                        if (obj == null) {
                            obj = loino.filter { i ->
                                i.INOT_PROD == oino.INOT_PROD
                                        && i.INOT_QTD != i.INOT_QTDCONT
                            }.getOrNull(0)
                        }
                        if (obj != null) {
                            if (obj.INOT_PROD != oino.INOT_PROD) {
                                obj = loino.filter { i ->
                                    i.INOT_PROD == oino.INOT_PROD
                                            && i.INOT_QTD != i.INOT_QTDCONT
                                }.getOrNull(0)
                            }
                        }
                        if (_inProduto.text().ffCopy(14, 9).ffVsi() != 0) {
                            println0("@invetigando 7z")
                            obj = loino.filter { i ->
                                i.INOT_PROD == oino.INOT_PROD
                                        && i.INOT_ORDEM == oino.INOT_ORDEM
                            }.getOrNull(0)
                            if (oino.INOT_QTDCONT >= obj!!.INOT_QTD) {
                                ffMsgAviso("Lote já foi conferido, quantidade OK!")
                                obj = null
                            }
                        }

                        println0("@investigar isso")
                        println0(obj)

                        if (obj != null) {
                            if (opro != null && _inProduto.text().length > 6) {
                                oino.ESTG_TIPO = opro!!.ESTG_TIPO
                                oino.ESTG_UNIDVENDA = opro!!.ESTG_UNIDVENDA
                            }

                            if (oino.ESTG_TIPO.equals("C"))
                                _inProdutoQtd.text("CAIXA COM " + oino.ESTG_UNIDVENDA.toString() + " UNIDADES")
                            if (oino.ESTG_TIPO.equals("D"))
                                _inProdutoQtd.text("DISPLAY COM " + oino.ESTG_UNIDVENDA.toString() + " UNIDADES")
                            oino = obj

                            _seOpcao.getHTMLSelectElement()!!.selectedIndex = _seOpcao.getSelectPos(oino.INOT_ORDEM.ffZeroLeft(3))
                            println0("@investigar selectedIndex ${_seOpcao.getHTMLSelectElement()!!.selectedIndex}")
                            _novo.value = true

                            _inProduto.text(oino.INOT_PROD.toString() + " - " + oino.INOT_DESCPROD)
                            _inProduto.textAnt("")
                            _inProduto.status("ok")
                            //_tela.value = "notas"

                            println0("zuza9999 lotexml ${oino.INOT_LOTEXML}")
                            println0(oino)
                            callback(true)
                        }
                    }
                }
            }
        }
    }

    fun _inProdutoFOCUSOUT1(
        _inProduto: MutableState<String>,
        _seOpcao: MutableState<String>,
        _inProdutoQtd: MutableState<String>,
        _novo: MutableState<Boolean>,
        _inot_qtdcont: MutableState<String>,
        _tela: MutableState<String>,
        _gravar: String
    ) {

        println0("@investigar _inProdutoFOCUSOUT1 ${_inProduto.text()}")
        if (!_inProduto.text().equals("")) {
            _inProdutoFocusOut(_inProduto, _seOpcao, _inProdutoQtd, _novo) { o ->

                //ffMsgWindow("_inProduto.status ${_inProduto.status()}")
                if (o) {
                    _tela.value = "notaItem"
                    //_inot_qtdcont.setFocus()
                    if (_inot_qtdcont.text().ffVsdo() < 1.0)
                        _inot_qtdcont.text("1")
                    if (!_gravar.equals("continuo")) {
                        _inot_qtdcont.setFocusSimples(true)
                        if (!gsBrowser.contains("mobile"))
                            _inot_qtdcont.select()
                    }
//                    if (bAuto) {
//                        println0("@bAuto muda o status do botão btGravar")
//                        _btGravar.status("ok")
//                    }
                    if (oino.INOT_QTDCONT < oino.INOT_QTD)
                        ffAudio().ffPlayBeep(true)
                    else
                        ffAudio().ffPlayBeep(false)
                } else {
                    ffAudio().ffPlayBeep(false)
                }
            }
        }
    }

    fun _inot_qtdcontFOCUSIN(
        _seOpcao: MutableState<String>,
        _btGravar: MutableState<String>,
        _inProduto: MutableState<String>,
        _inQtd: MutableState<String>,
    ) {
        if (!_inProduto.text().equals("")) {

            println0("zuza9997 - textSelect=" + _seOpcao.textSelect())
            println0("value=" + _seOpcao.getHTMLSelectElement()!!.value)

            println0("btGravar=" + _btGravar.value)
            //if (onot.NOT_FINALIDADE == 1 && oino.EST_CONTRLOTE.equals("S") && _seOpcao.selectCount("fal-") > 0 && _seOpcao.textSelect().contains("/bat")) {
            if (onot.NOT_FINALIDADE == 1 && _seOpcao.selectCount("fal-") > 0 && !_btGravar.enabled() && _inQtd.text().ffVsc() > 0)
                _seOpcao.comboLocaliza(_seOpcao.textSelect(_seOpcao.selectLocalize("fal-")))

            if (!_btGravar.status().equals("continuo"))
                _btGravar.enabled(true)

            if (_inQtd.text() == "1")
                if (_inQtd.inputExiste())
                    _inQtd.getHTMLInputElement()!!.select()
                    //_inQtd.select()
        }

    }
}
